import styled from "styled-components";
import {baseColors} from "../../../../themes/definitions/harrahs/base-colors";
import {HeaderNavbarContainerDefaultBox} from "./header-navbar-container.default.box";

export const HeaderNavbarContainerHarrahsBox = styled(HeaderNavbarContainerDefaultBox)`
  @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
    background: linear-gradient(#000000 35%, ${baseColors.gray033} 100%);
  }

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    border-bottom: none;
  }
`;

